import React from 'react'
import { Dejargonator, TextBody } from '@ally/metronome-ui'
import { InterestRateToggle } from '../InterestRateToggle'
import { AccountDetails } from '../../../types'
import {
  AcctDetailsItem,
  Dt,
  LightDejargBody,
  StyledDejargTrigger,
} from './StyledDlElements'

interface InterestRateDlProps {
  account: AccountDetails
}

export const InterestRateDl: React.FC<InterestRateDlProps> = ({ account }) => (
  <AcctDetailsItem>
    <Dt>
      <Dejargonator
        trigger={{
          content: (
            <StyledDejargTrigger>
              <TextBody size="sm" tag="span" weight="bold">
                Interest Rate:
              </TextBody>
            </StyledDejargTrigger>
          ),
          variant: 'element',
          ariaLabel: 'interest rate',
        }}
        body={
          <LightDejargBody size="sm" tag="p" weight="normal">
            We compound interest on a daily basis using the daily balance
            method. This method applies a daily periodic rate to the principal
            and interest that has accrued to the account each day. We calculate
            the daily periodic rate by dividing the interest rate by 365 days,
            even in leap years. The full, 5-digit interest rate is used for this
            calculation.
          </LightDejargBody>
        }
        ariaLabelPopover="We compound interest
              on a daily basis using the daily balance method."
      />
    </Dt>
    <InterestRateToggle account={account} />
  </AcctDetailsItem>
)
